import { render, staticRenderFns } from "./SettingsTheme.vue?vue&type=template&id=4717a9f9"
import script from "./SettingsTheme.vue?vue&type=script&lang=js"
export * from "./SettingsTheme.vue?vue&type=script&lang=js"
import style0 from "./SettingsTheme.vue?vue&type=style&index=0&id=4717a9f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports